import React from "react";
import { Box } from "@chakra-ui/react";
import { Column, FilterDefinition } from "hooks/useTable";
import { Partner } from "redux/partners/reducer";
import GamelightTable from "components/table";
import { getPartners } from "views/admin/partners/services";
import { TableContextProvider } from "contexts/TableContext";

const COLUMNS: Column<Partner>[] = [
  { columnKey: "companyName", header: "COMPANY NAME" },
  { columnKey: "firstName", header: "FIRST NAME" },
  { columnKey: "lastName", header: "LAST NAME" },
  { columnKey: "mail", header: "E-MAIL" },
  { columnKey: "accountManagerNames", header: "ACCOUNT MANAGERS" },
];

const FILTERS: FilterDefinition[] = [
  {
    label: "Only With Campaigns",
    filterKey: "hasAtLeastOneCampaign",
    type: "checkbox",
    defaultValue: true,
  },
];

export default function Partners() {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <TableContextProvider>
        <GamelightTable
          columns={COLUMNS}
          filters={FILTERS}
          fetchData={getPartners}
          uniqueKey="partnerId"
          title="Partners"
          rowConfig={{
            href: (row) => `/partner/${row.partnerId}`,
          }}
          shouldSearch
          searchPlaceHolder="Search partners..."
        />
      </TableContextProvider>
    </Box>
  );
}
